// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Vm-z","tupacHeader":"Wm-z","tupacHeader2":"Xm-z","tupacMenu":"Ym-z","tupacMenu2":"Zm-z","tupacMain":"_m-z","tupacMain2":"an-z"};